// Author Liang Gang Qiang
// Date 2021-12-10 14:28:23

import * as model from "@/model/sithMes/quality/SithMesQualityInspectCommonTemplateModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {customVuexFilterPatternFactory} from "@/store/em/commonPattern/customVuexFilterPatternFactory";
import {customVuexVoPatternFactory} from "@/store/em/commonPattern/customVuexVoPatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesQualityInspectCommonTemplate(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_QUALITY_URL,
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'withOperationFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'withOutFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'withOperationVo'
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'withOutVo'
    })
    .buildStore()
